import React from 'react';
import {PreRegistComponent} from '../../components/Agency';

export const AgencyPreRegist: React.FC = React.memo(() => {
  return <PreRegistComponent />;
});
